import WelcomeFlow from './Views/WelcomeFlow.vue';

export default [
    {
        path: '/welcome-flow',
        name: 'Welcome Flow',
        meta: {
            allowAnonymous: true,
            title: 'Welcome to Carbucks'
        },
        component: WelcomeFlow
    }
];